import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Editor, schema, Toolbar } from 'ngx-editor';
import { AnnouncementsService } from './announcements.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../../../../../shared/components/alert-dialog/alert-dialog.component';
import { toHTML } from 'ngx-editor';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss']
})

export class AnnouncementsComponent implements OnInit, OnDestroy {
  adminForm!: FormGroup;
  public editor!: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  checkReq: boolean = false;
  checkType = false;
  salesConfirm: boolean = false;
  totalEmails: boolean = false;
  emails: string = '';

  constructor(
    private announceService: AnnouncementsService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.editor = new Editor();
    this.adminForm = new FormGroup({
      'announcementSubject': new FormControl(null, [Validators.required]),
      'announcementBody': new FormControl(null, [Validators.required]),
      'salesAmount': new FormControl(null, [Validators.required]),
      'emailAnnouncement': new FormControl(false),
      'webAnnouncement': new FormControl(false),
      'businessOwnersOnly': new FormControl(false, [Validators.required]),
      'lang': new FormControl(null, [Validators.required]),
      'salesComparison': new FormControl(null, [Validators.required]),
      'businessStatusUnverified': new FormControl(false),
      'businessStatusVerified': new FormControl(false),
      'businessStatusActive': new FormControl(false),
      'businessStatusInactive': new FormControl(false),
      'businessStatusBlocked': new FormControl(false),
    });
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  async submit() {
    try{
    if (this.adminForm.controls['announcementBody'].value) {
      let bodyValue: string = '';
      bodyValue = toHTML(this.adminForm.controls['announcementBody'].value, schema);
      this.adminForm.controls['announcementBody'].setValue(bodyValue);
    } else {
      this.checkReq = true;
      return;
    }
    if (!this.adminForm.value['businessStatusUnverified'] && !this.adminForm.value['businessStatusActive']
      && !this.adminForm.value['businessStatusInactive'] && !this.adminForm.value['businessStatusBlocked']
      && !this.adminForm.value['businessStatusVerified']) {
      this.checkReq = true;
      return;
    }

    if (!this.adminForm.value['webAnnouncement'] && !this.adminForm.value['emailAnnouncement']) {
      this.checkType = true;
      return;
    }

    this.announceService.setParams({ ...this.adminForm.value, 'confirmSend': false });
    let res: any = await this.announceService.make();
    this.emails = res.count;
    let msg = res.count + " users will receive this announcement, Are you sure?";
    const dialogRef = this.openDialog(msg, true);
    const r = await dialogRef.afterClosed().toPromise();
    if (!r) {
      return;
    }
    this.announceService.setParams({ ...this.adminForm.value, 'confirmSend': true });
    res = await this.announceService.make();
    msg = `Announcement sent successfully`;
    this.adminForm.reset();
    this.totalEmails = true;
    if (res.status === 'success') {
      const dialog = this.openDialog(msg, false);
      setTimeout(() => {
        dialog.close();
      }, 3000);
    } else {
      const dialog = this.openDialog('Error', false);
      setTimeout(() => {
        dialog.close();
      }, 3000);
    }
  }catch(err){
    console.log(err);
  }
  }

  openDialog(msg: string, question: boolean) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: msg,
        question: question
      },
    });
    return dialogRef
  }
}
